import { Toast } from 'vant'
// 我的拼团详情
export function actGroupBuyDetail (params) {
  let isOrderDetails = params.isOrderDetails
  delete params.isOrderDetails
  // return Promise.resolve(
  //     {
  //         "code": 200,
  //         "data": {
  //             "actCode": "ActPromotion1652078420737vq",
  //             "actId": 350,
  //             "actStatus": 1,
  //             "createdTime": 1652513806000,
  //             "expireTime": 1652514106000,
  //             "goodsId": 10436,
  //             "groupCode": "1525379578545381376",
  //             "groupNum": 4,
  //             "groupType": 1,
  //             "id": 198,
  //             "isLeader": true,
  //             "joinNum": 0,
  //             "leaderEmpNo": "FC004840",
  //             "leaderUserId": 0,
  //             "members": [
  //                 {
  //                     "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJRgMw7FHDF5PdsOibTEsTtckNS2R8V2m0zFemiaXYrIwiaIJE4LKMBfl5ah7yx41r8t3QOaGxCWhYRw/132",
  //                     "createdTime": 1652513806000,
  //                     "empNo": "FC004840",
  //                     "groupCode": "1525379578545381376",
  //                     "id": 0,
  //                     "memberFlag": 1,
  //                     "orderId": 0,
  //                     "orderSn": "",
  //                     "userId": 0,
  //                     "userName": "暮光"
  //                 }
  //             ],
  //             "orderSn": "",
  //             "status": 0
  //         },
  //         "errCaused": "",
  //         "message": "SUCCESS"
  //     });
  return this.fetch({
    method: 'GET',
    url: 'mall-server/api/act/groupbuy/v1/actGroupBuyDetail', // TODO
    params,
    errorHandle: isOrderDetails
      ? data => {
          // 在orderdetails里查询团详情不能报这个错
          // 也不能通过vue那边传入,这边收不到的
          if (data.message != '拼团订单不存在') {
            Toast({
              type: 'fail',
              message: data.message
            })
          }
        }
      : undefined
  })
}
// 商品详情-团购下单详情接口-支付之前请求 和saveOrderGroupBuy 一起使用
// export function groupBuyNew (params) {
//   return this.fetch({
//     method: 'GET',
//     url: 'mall-server/api/order/v3/groupBuy',
//     params
//   })
// }
// 二维码
// export function combine (data) {
//   return this.fetch({
//     method: 'POST',
//     url: 'mini-program-server/api/util/with/wxacode/unlimited/image/combine',
//     data
//   })
// }

